webpackJsonp([163688151951553],{

/***/ 480:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Features = __webpack_require__(20);
	
	var _Features2 = _interopRequireDefault(_Features);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _QuickstartBranch = __webpack_require__(8);
	
	var _QuickstartBranch2 = _interopRequireDefault(_QuickstartBranch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Features2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Dialogs'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Useful for launching a user experience outside the UI of the main application. You can think of dialogs as mini-apps that you launch to perform a task, and that you may need to reuse in multiple places in the application.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The ',
	      _react2.default.createElement(
	        'em',
	        null,
	        'behavior'
	      ),
	      ' of dialogs tends to be fairly similar across applications, but the visual appearance and content can drastically based on an application\'s branding.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Because of that, Lore doesn\'t provide a built-in solution for dialogs per se, but there\'s a side-project called ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'lore-forms'
	      ),
	      ' that illustrates some patterns for building dialogs that you may find helpful. It also includes implementations of those patterns for the Bootstrap and Material UI component libraries.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'You can read more about ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'lore-forms'
	      ),
	      ' ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/forms/' },
	        'here'
	      ),
	      '.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-features-dialogs-js-b8dc04d7691c26266980.js